export const TagTypes = {
    dealership: 1,
    oem: 2
};